const muiThemeColors = ['default', 'inherit', 'primary', 'secondary'];
export default muiThemeColors;
